import * as React from 'react';

import classnames from 'classnames';

import styles from './scrollable-section.module.css';

type Props = {
    hasTopBorder?: boolean;
    hasBottomBorder?: boolean;
    children: React.ReactNode;
};

export class ScrollableSection extends React.PureComponent<Props> {
    render() {
        const stylename = classnames(styles['scrollable-section'], {
            [styles['border-top']]: this.props.hasTopBorder,
            [styles['border-bottom']]: this.props.hasBottomBorder,
        });

        return <div className={stylename}>{this.props.children}</div>;
    }
}
